import { FC, SVGAttributes } from "react";

const Lens: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="95px"
    height="95px"
    viewBox="0 0 95 95"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Filters---Container-Sizes"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="00-Level-1---Extreme-filters---No-result"
        transform="translate(-817.000000, -544.000000)"
        stroke="#000000"
        strokeWidth="1.97"
      >
        <g id="Group-32" transform="translate(448.000000, 464.000000)">
          <g id="Group-4" transform="translate(370.000000, 81.000000)">
            <circle id="Oval" cx="34.48" cy="34.48" r="34.48" />
            <circle id="Oval" cx="34.48" cy="34.48" r="26.6" />
            <path
              d="M66.5,59.6 L59.6,66.5 L84.3,91.18 C85.2173622,92.0915692 86.4567523,92.6052874 87.75,92.61 L87.75,92.61 C90.4428676,92.6044987 92.6244987,90.4228676 92.63,87.73 L92.63,87.73 C92.6147359,86.4408473 92.0940656,85.2091928 91.18,84.3 L66.5,59.6 Z"
              id="Path"
            />
            <polyline
              id="Path"
              points="60.75 56.81 65.02 61.08 61.08 65.02 56.81 60.75"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export { Lens };
